import SearchUtil from './util/SearchUtil';

import _ from 'underscore';
import BulkActionOptions from "./util/BulkActionOptions";
import NumberUtil from "$flx/util/NumberUtil";
export default {
    data () {
        return {

            //YOU MUST SET THIS IN THE COMPONENT THAT USES THE MIXIN
            searchCacheKey : null,
            apiSearchMethod : null,
            apiExportMethod : null,
            exportJobType : null,
            availableFields : {},
            defaultProjectionColumns : [],
            vuexSearchFilterStore : null,
            vuexSearchProjectionStore : null,
            defaultSortColumnHandle : null,
            defaultSortDescending : true,
            //END MUST SETS

            //OPTIONAL SETTING IN COMPONENTS THAT USE MIXIN

            allowMultiplePaginationStyles : false,

            //can be used to persist any generic filters
            genericFilters : {},

            //can be used to cache any generic data (ie the collapsed state of something etc)
            genericCache : {},

            //END OPTIONAL

            itemSelectedKey : '__selected',

            //Allows using your own component to render each table row rather using the default iteration of fields
            customTableRowRenderComponent : "tr",
            //Allows passing custom props to the table row rendered component
            customTableRowRenderComponentProps : {},

            hideExport : false,
            supportsBulkActions : true,
            bulkActionItemNoun : 'items',
            bulkActionItems : [],
            bulkActionExportMethodOverride : null,
            bulkActionItemIdKey : 'id',

            mounted : false,
            fetching : true,

            fetchingTotal : false,

            filters : {
                offset : 0,
                limit : 50,
                search : null,
                sortColumnHandle : null,
                sortDescending : true,
                filters : [],
                projectionId : null,
                //TODO think about this
                searchColumns : [SearchUtil.DEFAULT_SEARCH_FIELDS_HANDLE],
                //TODO think about this
                searchType : SearchUtil.FUZZY_SEARCH,
                projectionColumns : [],
                dynamicFilters : [],
                bulkActionType : BulkActionOptions.SELECTED,
            },


            data : {
                items : [],
                total : 0,
            },

            appliedFilters : [],

            limitOptions : [
                {
                    id : 25,
                    name : '25 Per Page',
                    value : 25
                },
                {
                    id : 50,
                    name : '50 Per Page',
                    value : 50
                },
                {
                    id : 100,
                    name : '100 Per Page',
                    value : 100
                },
                {
                    id : 500,
                    name : '500 Per Page',
                    value : 500
                },
                {
                    id : 1000,
                    name : '1,000 Per Page',
                    value : 1000
                }
            ],

            filtersModal : {
                active : false,
                changedIds : [],
                deletedIds : [],
                open : () => {
                    this.filtersModal.changedIds = [];
                    this.filtersModal.deletedIds = [];
                    this.filtersModal.active = true;
                },
                close : () => {
                    let refresh = false;
                    //if any of the active filters being applied were deleted
                    if(_.intersection(this.filtersModal.deletedIds, this.selectedSearchFilterIds).length){
                        refresh = true;
                        //remove them from the selected list
                        this.filters.filters = _.reject(this.filters.filters, f => {
                            return this.filtersModal.deletedIds.indexOf(f.id) !== -1;
                        })
                    }
                    //if any of the active filters being used changed we need to refresh
                    if(_.intersection(this.filtersModal.changedIds, this.selectedSearchFilterIds).length){
                        refresh = true;
                    }
                    if(refresh){
                        this.fetchItems(true);
                    }
                    this.filtersModal.active = false;
                },
            },

            projectionsModal : {
                active : false,
                changedIds : [],
                deletedIds : [],
                open : () => {
                    this.projectionsModal.changedIds = [];
                    this.projectionsModal.deletedIds = [];
                    this.projectionsModal.active = true;
                },
                close : () => {
                    let refresh = false;
                    if(
                        this.filters.projectionId
                        && this.projectionsModal.changedIds.concat(this.projectionsModal.deletedIds).indexOf(this.filters.projectionId) !== -1
                    ){
                        refresh = true;
                    }
                    if(refresh){
                        this.fetchItems();
                    }
                    this.projectionsModal.active = false;
                },
            },

            exportFlyout : {
                loading : false,
                active : false,
                job : null,
            },

            datePickers : {
                start : null,
                end : null
            },

            searchText : '',

            confirmActionModal : {
                active : false,
                callback : () => {},
                text : null,
                subText : null,
                loading : false,
            },

            paginationModal : {
                active : false,
                originalValue : null,
                currentTotal : null,
                fetchingTotal : false,
                forceGettingTotalOnNextRequest : false,
                open : () => {
                    this.paginationModal.originalValue = this.isPaginationExact;
                    this.paginationModal.active = true;
                },
                close : () => {
                    this.paginationModal.active = false;
                    this.paginationModal.currentTotal = null;
                    this.paginationModal.forceGettingTotalOnNextRequest = false;
                },
                apply : () => {
                    if(this.paginationModal.originalValue !== this.isPaginationExact) {
                        this.isPaginationExact = this.paginationModal.originalValue;
                        if(this.isPaginationExact) {
                            this.paginationModal.forceGettingTotalOnNextRequest = true;
                            this.fetchItems();
                        }
                    }
                    this.paginationModal.close();
                },
                fetchTotal : () => {
                    this.paginationModal.fetchingTotal = true;
                    const request = this.getFetchRequestContextMassaged();
                    request.totalOnly = true;
                    this.apiSearchMethod(request).then(response => {
                        this.paginationModal.currentTotal = response.data.total;
                    }).finally(() => {
                        this.paginationModal.fetchingTotal = false;
                    });
                },
            },
            paginationOptions : [
                { value : false, label : 'Page number only, no total counts (best performance)'},
                { value : true, label : 'Show exact number of items and offsets (worse performance)'},
            ],

            fetchingTotalForValidationModal : false,

            disabled : {
                itemIds : [],
                idFieldName : 'id',
                rowClasses : 'disabled-row-gray1',
                rowTooltip : 'Item cannot be selected',
            },

        }
    },
    mounted () {

        let savedContext = this.$store.state.searchCache[this.searchCacheKey];

        if(savedContext){
            this.filters = Object.assign({}, _.defaults(savedContext.filters, this.filters));
            if(savedContext.appliedFilters) {
                this.appliedFilters = savedContext.appliedFilters;
            }
            if(savedContext.genericFilters) {
                this.genericFilters = savedContext.genericFilters;
            }
            if(savedContext.genericCache) {
                this.genericCache = savedContext.genericCache;
            }
            if(this.searchCacheApplier) {
                this.searchCacheApplier(savedContext);
            }
        }

        if(!this.filters.projectionColumns.length) {
            this.filters.projectionColumns = this.defaultProjectionColumns;
        }

        if(this.filters.search){
            this.searchText = this.filters.search;
        }

        if(!this.filters.sortColumnHandle) {
            this.filters.sortColumnHandle = this.defaultSortColumnHandle;
            if(!this.defaultSortDescending) {
                this.filters.sortDescending = false;
            }
        }

        let promises = [];

        if(this.vuexSearchFilterStore) {
            promises.push(
                this.$store.dispatch(this.vuexSearchFilterStore.GET).then(filters => {
                    //if a filter was deleted from another screen and it's still saved we need to remove it from the active list
                    if (savedContext && savedContext.selectedFilterIds.length) {
                        this.filters.filters = _.filter(filters, sf => {
                            return savedContext.selectedFilterIds.indexOf(sf.id) !== -1;
                        });
                    }
                })
            );
        }

        if(this.vuexSearchProjectionStore) {
            promises.push(
                this.$store.dispatch(this.vuexSearchProjectionStore.GET).then(projections => {
                    //if the saved projection was deleted from another screen remove it's usage and use the default
                    if (
                        savedContext
                        && savedContext.projectionId
                        && _.pluck(projections, 'id').indexOf(savedContext.projectionId) === -1
                    ) {
                        this.filters.projectionIdj = null;
                    }
                })
            );
        }

        const customBeforeMountPromise = this.fetchBeforeMount();
        if(customBeforeMountPromise) {
            if(_.isArray(customBeforeMountPromise)) {
                promises = promises.concat(customBeforeMountPromise);
            } else {
                promises.push(customBeforeMountPromise);
            }
        }

        Promise.all(promises).then(() => {
            this.fetchItems();
        });
    },

    beforeDestroy () {

        const filters = this.getFetchRequestContext();
        //only store the ids of the filters and not the whole object so changes
        //aren't as hard to keep in sync
        const selectedFilterIds = _.pluck(this.filters.filters, 'id');
        delete filters.filters;

        //remove the projection columns
        filters.projectionId = this.filters.projectionId;

        const additionalData = this.searchCacheAugmenter ? this.searchCacheAugmenter() : {};

        const context = {
            filters : filters,
            selectedFilterIds : selectedFilterIds,
            appliedFilters : this.appliedFilters,
            genericFilters : this.genericFilters,
            genericCache : this.genericCache,
            ...additionalData,
        };

        this.$store.commit('setSearchCache', {
            cacheKey : this.searchCacheKey,
            cacheValue : context,
        });
    },


    computed : {

        selectedSearchFilterIds () {
            return _.pluck(this.filters.filters, 'id');
        },

        groupedAppliedFilters () {
            return Object.values(_.groupBy(this.appliedFilters, 'group'));
        },

        selectedProjection () {
            return _.findWhere(this.$store.state[this.vuexSearchProjectionStore].contexts, { id : this.filters.projectionId });
        },

        availableProjectionGroups () {
            return this.availableFields.groupedFields.map(group => {
                return {
                    groupName : group.groupName,
                    fields : group.fields.filter(field => {
                        //null means it's available
                        return field.projectionViewable !== false;
                    }),
                }
            }).filter(group => group.fields.length)
        },

        availableProjectionFields () {
            return this.availableFields.fields.filter(field => {
                return field.projectionViewable !== false;
            });
        },

        activeProjectionFields () {
            return this.filters.projectionColumns.map(columnHandle => {
                return _.findWhere(this.availableFields.fields, { handle : columnHandle });
            });
        },

        selectedItems () {
            return _.where(this.data.items, { [this.itemSelectedKey] : true });
        },

        estimatingTotalCount () {
            return this.estimateTotal
                && !this.filters.dynamicFilters.length
                && !this.filters.filters.length
                && !this.filters.search;
        },

        isPaginationExact : {
            get() {
                return this.$store.state[this.$STORE_CONSTANTS.PAGINATION_STYLE_EXACT];
            },
            set (value) {
                this.$store.commit(this.$STORE_CONSTANTS.PAGINATION_STYLE_EXACT.SET, value);
            },
        },

        bulkActionShowSelectAll () {
            return this.supportsBulkActions && this.selectedItems.length === this.filters.limit
        },


        isBulkActionAll () {
            return this.filters.bulkActionType === BulkActionOptions.ALL;
        },

    },
    methods : {

        //METHODS THAT CAN BE OVERRIDDEN

        //allows you to perform some sort of networks requests before we make our first request to the backend
        //MUST RETURN A PROMISE OR AN ARRAY OF PROMISES
        fetchBeforeMount () {
        },

        //apply data back into your state that was added via `searchCacheAugmenter` during the beforeMount hook
        searchCacheApplier (savedContext) { // eslint-disable-line no-unused-vars
            //do nothing
        },

        //add additional data to the saved search cache during beforeDestroy
        searchCacheAugmenter () {
            return {};
        },

        //transform the data that comes from the API
        //searchResultItemsTransformer : null,

        //add additional data to the search request context
        //fetchRequestContextAugmenter : null,

        //do something (ie link to new page) when row is clicked
        onItemRowClick (item) { // eslint-disable-line no-unused-vars
            //nothing by default
        },

        //handle a inner TD custom component broadcasting some sort of event
        onBroadcast (eventContext) { // eslint-disable-line no-unused-vars
            //nothing by default
        },

        // set disabled items : you can set `this.disabled.itemIds` based on some condition by overriding this method
        seedDisabledItems (){
            return {};
        },

        removeFilter (context) {
            this.filters.filters = _.reject(this.filters.filters, { id : context.id });
            this.appliedFilters = _.reject(this.appliedFilters, { id : context.id });
            this.fetchItems(true);
        },

        applyFilter (context) {

            const group = 'Filter';
            const filterContext = {
                onRemoveEventName : 'remove-filter',
                id : context.filter.id,
                group : group,
                label : context.filter.filter.name,
            };

            const add = () => {
                this.appliedFilters.push(filterContext);
            };

            if(this.selectedSearchFilterIds.indexOf(context.filter.id) !== -1){
                this.removeFilter(filterContext);
            } else {
                if(context.addToSelection){
                    this.filters.filters.push(context.filter);
                } else {
                    this.appliedFilters = _.reject(this.appliedFilters, { group : group });
                    this.filters.filters = [context.filter];
                }
                add();
                this.fetchItems(true);
            }
        },

        getFetchRequestContext () {
            const additional = this.fetchRequestContextAugmenter ? this.fetchRequestContextAugmenter() : {};
            return {
                offset : this.filters.offset,
                limit : this.filters.limit,
                //if we are coming back to a page > 1 from a saved filter we need to request the total again
                needTotal : !this.mounted || this.filters.offset === 0 || this.paginationModal.forceGettingTotalOnNextRequest,
                paginationExact : this.isPaginationExact || !this.allowMultiplePaginationStyles,
                search : this.filters.search,
                sortColumnHandle : this.filters.sortColumnHandle,
                sortDescending : this.filters.sortDescending,
                filters : _.pluck(this.filters.filters, 'filter'),
                projectionColumns : this.filters.projectionColumns,
                searchColumns : this.filters.searchColumns,
                searchType : this.filters.searchType,
                dynamicFilters : this.filters.dynamicFilters,
                bulkActionType : this.filters.bulkActionType,
                //add any generic filters as top level keys in the request context
                ...this.genericFilters,
                ...additional,
            };
        },

        getFetchRequestContextMassaged () {

            const request = this.getFetchRequestContext();

            if(request.searchColumns[0] === SearchUtil.ACTIVE_PROJECTION_HANDLE) {
                //only take the searchable fields from the active projection
                request.searchColumns = _.intersection(this.filters.projectionColumns, this.availableFields.searchableFieldHandles);
            } else if(request.searchColumns[0] === SearchUtil.DEFAULT_SEARCH_FIELDS_HANDLE){
                request.searchColumns = null;
            }

            return request;

        },

        fetchItems (fromStart) {
            this.fetching = true;
            if(fromStart) {
                this.filters.offset = 0;
                this.data.total = 0;
            }

            this.apiSearchMethod(this.getFetchRequestContextMassaged()).then(response => {

                if(response.data.total !== null) {
                    this.data.total = response.data.total;
                } else if (response.data.items.length < this.filters.limit) {
                    this.data.total = response.data.items.length;
                }

                //if there is a transformer for the result items let it operate on the whole response
                //otherwise just assign from key items
                this.data.items = this.searchResultItemsTransformer ? this.searchResultItemsTransformer(response.data) : response.data.items;

                this.seedDisabledItems(this.data.items);

                //after any request we set the bulk action type back to selected to prevent displaying 0 in the total items
                //and to reset back to our standard selection
                this.filters.bulkActionType = BulkActionOptions.SELECTED;

                if(!this.mounted){
                    this.mounted = true;
                }
                this.fetching = false;
            });
        },

        fetchTotal () {
            this.fetchingTotal = true;
            const request = this.getFetchRequestContextMassaged();
            request.totalOnly = true;
            return this.apiSearchMethod(request).then(response => {
                this.fetchingTotal = false;
                this.data.total = response.data.total;
                return response.data.total;
            });
        },

        toggleItemSelection (event, item) {
            event.stopPropagation();
            if(item[this.itemSelectedKey] && this.isBulkActionAll) {
                this.filters.bulkActionType = BulkActionOptions.SELECTED;
            }
            this.$set(item, this.itemSelectedKey, !item[this.itemSelectedKey]);
        },

        toggleSelectAllItems (selected) {
            this.data.items.forEach(item => {
                this.$set(item, this.itemSelectedKey, selected);
            })
        },

        itemIsSelected (item) {
            return item[this.itemSelectedKey];
        },

        unSelectAllAndReFetch () {
            this.toggleSelectAllItems(false);
            this.fetchItems();
        },

        bulkActionTotalItems () {
            let totalItems = this.selectedItems.length;
            if(this.filters.bulkActionType === BulkActionOptions.ALL_ON_PAGE) {
                totalItems = this.data.items.length;
            } else if(this.filters.bulkActionType === BulkActionOptions.ALL) {
                totalItems = this.data.total;
            }
            return totalItems;
        },

        async validateBulkAction (action, optionalItemId) {

            if(
                !this.data.items.length
                && (
                    this.filters.bulkActionType === BulkActionOptions.ALL
                    || this.filters.bulkActionType === BulkActionOptions.ALL_ON_PAGE
                )
            ) {
                this.$notifyWarn(`There are no ${action}`);
                return Promise.reject();
            }

            if(!this.selectedItems.length && this.filters.bulkActionType === BulkActionOptions.SELECTED) {
                this.$notifyWarn(`You must select some ${action}`);
                return Promise.reject();
            }

            if(!this.data.total && this.filters.bulkActionType === BulkActionOptions.ALL) {
                this.fetchingTotalForValidationModal = true;
                this.data.total = await this.fetchTotal();
                this.fetchingTotalForValidationModal = false;
            }

            return new Promise(resolve => {

                let bulkActionItemIds = this.getBulkActionItemIds(optionalItemId);

                resolve({
                    ...this.getFetchRequestContextMassaged(),
                    bulkActionItemIds : bulkActionItemIds,
                    performBulkAction : true,
                    bulkActionTotalItems : this.bulkActionTotalItems(),
                    bulkActionTotalItemsFormatted : NumberUtil.withCommas(this.bulkActionTotalItems())
                });

            });
        },

        getBulkActionItemIds (optionalItemId) {

            const itemIdProperty = optionalItemId || this.bulkActionItemIdKey;
            let bulkActionItemIds = [];

            if(this.filters.bulkActionType === BulkActionOptions.ALL_ON_PAGE) {
                bulkActionItemIds = this.data.items.map(i => i[itemIdProperty])
            } else if(this.filters.bulkActionType === BulkActionOptions.SELECTED) {
                bulkActionItemIds = this.selectedItems.map(i => i[itemIdProperty])
            }
            return bulkActionItemIds;
        },

        openConfirmActionModal (text, callback) {
            this.confirmActionModal.active = true;
            this.confirmActionModal.callback = () => {
                this.confirmActionModal.loading = true;
                callback().finally(() => {
                    this.confirmActionModal.active = false;
                    this.confirmActionModal.loading = false;
                });
            };
            if(_.isObject(text)) {
                this.confirmActionModal.text = text.text;
                this.confirmActionModal.subText = text.subText;
            } else {
                this.confirmActionModal.text = text;
            }
        },

        changeLimit (limit) {
            this.filters.limit = limit;
            this.fetchItems();
        },

        changeSortColumn (columnHandle) {
            this.filters.sortColumnHandle = columnHandle;
            this.fetchItems(true);
        },

        changeSortDirection (toggle) {
            this.filters.sortDescending = toggle;
            this.fetchItems(true);
        },

        removeSearchFilter () {
            this.filters.search = '';
            this.appliedFilters = _.reject(this.appliedFilters, { group : 'Search' });
        },

        clearSearchFilter () {
            this.removeSearchFilter();
            this.fetchItems(true);
        },

        search (){

            if(!this.searchText) {
                this.clearSearchFilter();
                return;
            }

            this.removeSearchFilter();

            this.filters.search = this.searchText.toLowerCase();
            this.appliedFilters.push({
                onRemoveEventName : 'remove-search-filter',
                group : `Search`,
                label : `Search : ${this.filters.search}`,
            });
            this.fetchItems(true);
        },

        nextPage () {
            this.filters.offset += this.filters.limit;
            this.fetchItems();
        },

        previousPage () {
            this.filters.offset -= this.filters.limit;
            this.fetchItems();
        },

        changePage (page) {
            this.filters.offset = (page - 1) * this.filters.limit;
            this.fetchItems();
        },

        setSearchColumns (columns) {
            this.filters.searchColumns = columns;
        },

        searchColumnsChanged () {
            if(this.searchText){
                this.fetchItems(true);
            }
        },

        applyProjection (id) {
            this.filters.projectionId = id;
            this.filters.projectionColumns = id ? this.selectedProjection.projection.columns : this.defaultProjectionColumns;
            this.fetchItems();
        },

        addProjectionColumn (context) {
            const index = this.filters.projectionColumns.indexOf(context.fromHandle);
            this.filters.projectionColumns.splice(context.after ? index + 1 : index, 0, context.addHandle);
            this.fetchItems();
        },

        removeProjectionColumn (handle) {
            this.filters.projectionColumns = _.without(this.filters.projectionColumns, handle);
        },

        moveProjectionColumn (context) {
            const index = this.filters.projectionColumns.indexOf(context.handle) - 1;
            this.filters.projectionColumns = _.without(this.filters.projectionColumns, context.handle);
            this.filters.projectionColumns.splice(context.right ? index + 2 : index, 0, context.handle);
        },

        resetAllFilters () {
            Object.keys(this.genericFilters).forEach(key => {
                if(_.isArray(this.genericFilters[key])) {
                    this.genericFilters[key] = [];
                }
                else if(_.isObject(this.genericFilters[key])) {
                    this.genericFilters[key] = {};
                } else {
                    this.genericFilters[key] = null;
                }
            });
            this.filters.filters = [];
            this.filters.dynamicFilters = [];
            this.filters.searchText = null;
            this.appliedFilters = [];
        },

        removeDynamicFilter (context) {
            this.appliedFilters = _.reject(this.appliedFilters, { dynamicId : context.dynamicId });
            this.filters.dynamicFilters = this.filters.dynamicFilters.filter(df => df.dynamicId !== context.dynamicId);
            this.fetchItems(true);
        },

        addDynamicFilter (context) {
            this.addDynamicFilterWithoutFetch(context);
            this.fetchItems(true);
        },

        addDynamicFilterWithoutFetch (context) {
            const id = this.$uniqueId();
            context.condition.dynamicId = id;
            context.condition.groupId = !context.attachToGroup ? `dynamic-filter-${id}` : context.attachToGroup;
            this.appliedFilters.push({
                ...context,
                onRemoveEventName : 'remove-dynamic-filter',
                dynamicId : id,
                group : context.condition.groupId,
                isDynamicFilter : true,
            });
            this.filters.dynamicFilters.push(context.condition);
            this.filters.search = null;
        },

        removeGenericFilter(context) {
            this.appliedFilters = _.reject(this.appliedFilters, { uniqueId : context.uniqueId });
            if (_.isArray(this.genericFilters[context.genericFilterKey])) {
                this.genericFilters[context.genericFilterKey] = _.without(this.genericFilters[context.genericFilterKey], context.value);
            } else {
                this.genericFilters[context.genericFilterKey] = null;
            }
            this.fetchItems(true);
        },

        /**
         * Adds a value to a key in the generic filter object. Also builds a context to be placed in the applied filters to show what is
         * being applied to the current search results with the ability to click to remove the applied filter.
         *
         * @param addToSelection For array based filters whether to add the value to the current array or not.
         * @param label The label that is displayed in the UI.
         * @param group The group the filter belongs to (used to group similar filters together indicating and OR instead of and AND).
         * @param genericFilterKey The key the value is stored in in the generic filter object.
         * @param value The value of the filter.
         */
        addGenericFilter (addToSelection, label, group, genericFilterKey, value) {

            this.addGenericFilterWithoutFetch(addToSelection, label, group, genericFilterKey, value);

            this.fetchItems(true);
        },

        addGenericFilterWithoutFetch(addToSelection, label, group, genericFilterKey, value){
            const context = {
                onRemoveEventName : 'remove-generic-filter',
                uniqueId : `${group}-${label}`,
                group : group,
                label : label,
                genericFilterKey : genericFilterKey,
                value : value,
            };

            const add = () => {
                this.appliedFilters.push(context);
            };

            if(_.isArray(this.genericFilters[genericFilterKey])) {
                if(value === null){
                    this.genericFilters[genericFilterKey] = [];
                } else if(this.genericFilters[genericFilterKey].indexOf(value) !== -1){
                    this.removeGenericFilter(context);
                } else if(addToSelection) {
                    add();
                    this.genericFilters[genericFilterKey].push(value);
                } else {
                    this.appliedFilters = _.reject(this.appliedFilters, { group : group });
                    add();
                    this.genericFilters[genericFilterKey] = [value];
                }
            } else {
                this.appliedFilters = _.reject(this.appliedFilters, { group : group });
                if(this.genericFilters[genericFilterKey] !== value) {
                    add();
                    this.genericFilters[genericFilterKey] = value;
                }
            }
        },

        resetPaginationStyle () {
            this.isPaginationExact = false;
            this.fetchItems();
        },

        onExport (columns) {

            if(!columns.length) {
                this.$notifyError('You must select at least one column to export');
                return;
            }

            this.exportFlyout.loading = true;

            const request = {
                columns : columns,
                searchRequest : Object.assign(
                    this.getFetchRequestContextMassaged(),
                    {
                        bulkActionItemIds : this.getBulkActionItemIds(),
                    }
                )
            };

            request.searchRequest.projectionColumns = request.columns.map(c => c.handle);

            this.apiExportMethod(request).then((response) => {

                //create a download file
                if(_.isString(response.data)) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "export.csv"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    return;
                }

                this.exportFlyout.job = response.job;
                //else alert about the scheduled job etc

            }).finally(() => {
                this.exportFlyout.loading = false;
            });
        },

        onBulkActionMenuItemClicked (item) {
            if(!item.menuItems) {
                item.method();
                return;
            }
            const moveToState = !item.subMenuOpen;
            //close any other open ones
            this.bulkActionItems.forEach(i => {
                if(i.subMenuOpen) {
                    i.subMenuOpen = false;
                }
            });
            this.$set(item, 'subMenuOpen', moveToState);
        },

        bulkActionSelectAll () {
            if(!this.data.total) {
                this.fetchTotal();
            }
            this.filters.bulkActionType = BulkActionOptions.ALL;
        },

        bulkActionDeselectAll () {
            this.filters.bulkActionType = BulkActionOptions.SELECTED;
            this.toggleSelectAllItems(false);
        },

        onBulkActionExport () {
            if(this.bulkActionExportMethodOverride) {
                this.bulkActionExportMethodOverride();
            } else {
                this.exportFlyout.active = true;
            }
        },

    },
}
